import toolNames from './toolNames';
import {
  FaFingerprint,
  FaGlasses,
  FaPlay,
  FaPause,
  FaWindowClose,
  FaCube,
  FaProjectDiagram,
  FaPen,
  IoInvertMode,
  WiMoonAltFirstQuarter,
  FaSearch,
  FaRegHandPaper,
  FaCamera,
  IoLayersOutline,
  FaTh,
  FaTools,
  FaLanguage,
  FaUndo,
  FaPalette,
  BiIntersect,
  FaRegSquare,
  FaSquare,
  FaBorderAll,
  FaAngleRight,
  FaAngleLeft,
  FaAngleUp,
  FaAngleDown,
  FaList,
  FaWaveSquare,
} from '../../../../util/reactIcons';
import {
  languageOptions,
  layoutECGOptions,
  layoutOptions,
  hangingProtocolOptions,
} from '../../Viewer/Layout/LayoutsCollection';
import WLInputBox from './WLInputBox';
import MPRThicknessInputBox from '../../Viewer/renderer/Image3d/Toolbar3d/MPRThicknessInputBox';
import { palettesVR } from '../../../../util/palettesVRLoader';
import { ButtonEnabled } from '../../../../util/ToolbarUtils';
import { WLPresets } from './ToolOptions/WLPresetsOptions';
import { annotationsOptions } from './ToolOptions/AnnotationsOptions';
import RotationTriangleIcon, {
  HorizontalFlipIcon,
  HorizontallyFlippedRotationTriangleIcon,
  ResetPositionIcon,
  VerticalFlipIcon,
} from './RotationIcons';
import { EmptySquareIcon, FitToWindowIcon, PixelZoomIcon } from './ZoomIcons';

const getWLPresetLabel = (WLPreset) => `${WLPreset.name} (${WLPreset.data.windowWidth.toFixed(1)}, ${WLPreset.data.windowCenter.toFixed(1)})`;

export const toolsConfig = [
  {
    label: 'toolbar.window',
    name: toolNames.WWWC,
    icon: WiMoonAltFirstQuarter,
    type: 'button',
    keysPressed: { key: 'w' },
  },
  {
    label: 'toolbar.rotate',
    name: toolNames.ROTATE,
    icon: FaUndo,
    type: 'button',
    keysPressed: { key: 't' },
  },
  {
    label: 'toolbar.rotate',
    name: toolNames.ROTATE_MENU,
    icon: FaUndo,
    type: 'button',
    groupedTools: [],
    keysPressed: { key: '' },
  },
  {
    label: 'toolbar.clipping',
    labelToggled: 'toolbar.clipping',
    name: toolNames.CLIPPING,
    icon: FaSquare,
    iconToggled: FaBorderAll,
    type: 'toggle',
    keysPressed: { key: '' },
  },
  {
    label: 'toolbar.palettesVR',
    name: toolNames.PALETTES_VR,
    icon: FaPalette,
    type: 'options',
    options: palettesVR.map((paletteItem) => ({
        name: toolNames.PALETTE_VR,
        label: paletteItem.name,
        callback: undefined,
        icon: null,
        paletteName: paletteItem.name,
      })),
  },
  {
    label: 'toolbar.palettes',
    name: toolNames.PALETTES,
    icon: FaPalette,
    type: 'options',
    options: [
      {
        name: toolNames.GREYSCALE,
        label: 'greyScale',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.BONEPALETTE,
        label: 'bonePalette',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.AIRBONEPALETTE,
        label: 'airBonePalette',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.AIRPALETTE,
        label: 'airPalette',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.REDPALETTE,
        label: 'redPalette',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.FIREPALETTE,
        label: 'firePalette',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.ICEPALETTE,
        label: 'icePalette',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.RAINBOWPALETTE,
        label: 'rainBowPalette',
        callback: undefined,
        icon: null,
      },
    ],
  },
  {
    label: 'SL',
    name: toolNames.INTENSITY,
    icon: BiIntersect,
    iconSize: '1.6em',
    type: 'options',
    options: [
      {
        name: toolNames.INTENSITY_PROJECTION,
        value: '0',
        label: 'MIP',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.INTENSITY_PROJECTION,
        value: '1',
        label: 'MinIP',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.INTENSITY_PROJECTION,
        value: '2',
        label: 'Average',
        callback: undefined,
        icon: null,
      },
      {
        name: toolNames.THICKNESS,
        type: 'inputField',
        value: '0',
        label: 'Thickness',
        callback: undefined,
        renderInputBox: { InputBox: MPRThicknessInputBox },
        icon: null,
      },
    ],
  },
  {
    label: 'toolbar.2d',
    name: toolNames.MODE_2D,
    icon: FaRegSquare,
    type: 'button',
    keysPressed: { key: '' },
  },
  {
    label: 'toolbar.zoom',
    name: toolNames.ZOOM,
    icon: FaSearch,
    type: 'button',
    keysPressed: { key: 'e' },
  },
  {
    label: 'toolbar.zoom',
    name: toolNames.ZOOM_MENU,
    icon: FaSearch,
    type: 'options',
    options: [],
    dropdownMenuClassName: 'zoom-options-menu',
    isTool: true,
    activeToolName: toolNames.ZOOM,
    keysPressed: { key: 'e' },
  },
  {
    label: 'toolbar.zoomOneToOne',
    name: toolNames.ZOOM_1_TO_1,
    icon: PixelZoomIcon,
    type: 'button',
  },
  {
    label: 'toolbar.fitToWindow',
    name: toolNames.ZOOM_FIT,
    icon: FitToWindowIcon,
    type: 'button',
  },
  {
    label: 'toolbar.actualSize',
    name: toolNames.ZOOM_ACTUAL_SIZE,
    icon: EmptySquareIcon,
    type: 'button',
  },
  {
    label: 'toolbar.pan',
    name: toolNames.PAN,
    icon: FaRegHandPaper,
    type: 'button',
    keysPressed: { key: 'r' },
  },
  {
    label: 'toolbar.layout',
    name: toolNames.LAYOUT,
    icon: FaTh,
    type: 'options',
    options: layoutOptions(),
  },
  {
    label: 'toolbar.mpr',
    name: toolNames.MODE_MPR,
    icon: IoLayersOutline,
    type: 'button',
  },
  {
    label: 'toolbar.crossReference',
    name: toolNames.CROSS_REFERENCE,
    icon: BiIntersect,
    type: 'button',
  },
  {
    label: 'toolbar.3d',
    name: toolNames.MODE_3D,
    icon: FaCube,
    type: 'button',
  },
  {
    label: 'toolbar.annotations',
    name: toolNames.ANNOTATIONS,
    icon: FaPen,
    type: 'options',
    options: [
      ...annotationsOptions.map((annotationsOption) => ({
        ...annotationsOption,
      })),
    ],
  },
  {
    label: 'toolbar.groupedTools',
    name: toolNames.GROUPED_TOOLS,
    icon: FaTools,
    type: 'button',
    groupedTools: [],
    callback: undefined,
    keysPressed: { key: ' ' },
  },
  {
    label: 'toolbar.anonymize',
    name: toolNames.ANONYMIZE,
    icon: FaFingerprint,
    type: 'button',
    keysPressed: { key: '' },
  },
  {
    label: 'WL Presets',
    name: toolNames.WL_PRESETS,
    icon: WiMoonAltFirstQuarter,
    type: 'options',
    options: [
      ...WLPresets.map((WLPreset) => ({
          name: toolNames.WL_PRESET,
          label: getWLPresetLabel(WLPreset),
          callback: undefined,
          icon: null,
          WLPreset,
        })),
      {
        label: 'toolbar.windowInput',
        name: toolNames.WWWC_INPUT,
        type: 'inputField',
        renderInputBox: { InputBox: WLInputBox },
        callback: undefined,
        keysPressed: { key: ' ' },
      },
    ],
    keysPressed: { key: 'w' },
  },
  {
    label: 'toolbar.invert',
    name: toolNames.INVERT,
    icon: IoInvertMode,
    type: 'button',
    keysPressed: { key: '' },
  },
  {
    label: 'R-Turn',
    name: toolNames.ROTATE90,
    icon: HorizontallyFlippedRotationTriangleIcon,
    type: 'button',
    keysPressed: { key: '' },
  },
  {
    label: 'L-Turn',
    name: toolNames.ROTATE270,
    icon: RotationTriangleIcon,
    type: 'button',
    keysPressed: { key: '' },
  },
  {
    label: 'toolbar.hflip',
    name: toolNames.HFLIP,
    icon: HorizontalFlipIcon,
    type: 'button',
    keysPressed: { key: 'h' },
  },
  {
    label: 'toolbar.vflip',
    name: toolNames.VFLIP,
    icon: VerticalFlipIcon,
    type: 'button',
    keysPressed: { key: 'v' },
  },
  {
    label: 'Revert',
    name: toolNames.RESET_POSITION,
    icon: ResetPositionIcon,
    type: 'button',
    keysPressed: { key: '' },
  },
  {
    label: 'toolbar.magnify',
    name: toolNames.MAGNIFY_PLUS,
    icon: FaGlasses,
    type: 'button',
    keysPressed: { key: 'y' },
  },
  {
    label: 'toolbar.cine',
    labelToggled: 'toolbar.cineToggled',
    name: toolNames.CINE,
    icon: FaPlay,
    iconToggled: FaPause,
    type: 'toggle',
    keysPressed: { key: 'u' },
  },
  {
    label: 'toolbar.referenceLines',
    labelToggled: 'toolbar.referenceLinesToggled',
    name: toolNames.REF_LINES,
    icon: FaProjectDiagram,
    iconToggled: FaProjectDiagram,
    type: 'toggle',
    keysPressed: { key: 'q' },
  },
  {
    label: 'toolbar.screenshot',
    name: toolNames.SCREENSHOT,
    icon: FaCamera,
    type: 'options',
    disabled: () => !ButtonEnabled('CAPTURE'),
    options: [
      {
        name: toolNames.COPY_CAPTURE,
        label: 'toolbar.copyToClipboard',
        feedbackLabel: 'toolbar.captureCopied',
      },
      {
        name: toolNames.DOWNLOAD_CAPTURE,
        label: 'toolbar.downloadCapture',
      },
    ],
    selfReset: true,
    keysPressed: { key: '' },
  },
  {
    label: 'toolbar.reset',
    name: toolNames.RESET,
    icon: FaWindowClose,
    type: 'button',
    keysPressed: { key: ' ' },
  },
  {
    label: 'toolbar.language',
    name: toolNames.LANGUAGE,
    icon: FaLanguage,
    type: 'options',
    disabled: () => !ButtonEnabled('LANGUAGE'),
    options: languageOptions(),
    keysPressed: { key: 'l' },
  },
  {
    label: 'explorer.history',
    name: toolNames.HISTORY,
    icon: FaList,
    type: 'button',
    keysPressed: { key: 'i' },
  },

  /// ECG
  {
    label: 'toolbar.ECGDecreaseDuration',
    name: toolNames.DECREASE_SECONDS,
    icon: FaAngleLeft,
    type: 'button',
  },
  {
    label: 'toolbar.layout',
    name: toolNames.LAYOUT_ECG,
    icon: FaTh,
    type: 'options',
    options: layoutECGOptions(),
  },
  {
    label: 'toolbar.ECGIncreaseDuration',
    name: toolNames.INCREASE_SECONDS,
    icon: FaAngleRight,
    type: 'button',
  },
  {
    label: 'toolbar.ECGIncreaseVoltage',
    name: toolNames.INCREASE_VOLTAGE,
    icon: FaAngleUp,
    type: 'button',
  },
  {
    label: 'toolbar.ECGDecreaseVoltage',
    name: toolNames.DECREASE_VOLTAGE,
    icon: FaAngleDown,
    type: 'button',
  },
  {
    label: 'toolbar.ECG.layout.general',
    name: toolNames.LAYOUT_ECG_GENERAL,
    icon: FaWaveSquare,
    type: 'button',
  },
  {
    label: 'toolbar.ECG.layout.12',
    name: toolNames.LAYOUT_ECG_12,
    icon: FaWaveSquare,
    type: 'button',
  },
  {
    label: 'toolbar.ECG.layout.all',
    name: toolNames.LAYOUT_ECG_ALL,
    icon: FaWaveSquare,
    type: 'button',
  },
  {
    label: 'toolbar.hangingProtocols',
    name: toolNames.HANGING_PROTOCOLS,
    icon: IoLayersOutline,
    type: 'options',
    options: hangingProtocolOptions,
  },
];
